import React from 'react';

// import { Table } from 'react-bootstrap';

// import {renderTooltipMinReturns, renderTooltipMaxProbable, renderTooltipCAGRGroup } from './scheme_table_helpers';
// import {renderTooltipLaunchGroup, renderHeaderAndTooltip, renderTooltipMeanProbable } from './scheme_table_helpers';
// import {renderTooltipPredAnalysis, getVolatilityColor,  renderTooltipPNAVvolatility} from './scheme_table_helpers';

// import {isNegative, trendingDown, trendingColor, nameStyle, getPredAnalysisColor} from './scheme_table_helpers';

import SchemeListTable from './SchemeListTable'; 

import 'bootstrap/dist/css/bootstrap.min.css'; // Make sure Bootstrap CSS is imported
import './schemes_layout.css'; // Import the custom CSS file

// props: schemes, pageSizeDefault, topX, fundFilter, categoryFilter, etc.
export default function SchemeTable({
    pageData,
    baseScheme,
    handleCellClick=null,
    handleSort,
    renderSimpleSort,
    selectedScheme,
    sortField,
    sortDir,
    isAddToWatchlistApplicable = false,
  }) {
  const NO_USER_MANAGED_SORT=true;

  const getMultiSortIndicatorUpDown = (thisSortField, isASC, unitVal) => (
    <>
      {(sortField.length === 0) ? ((isASC ? '▲' : '▼') + unitVal) : ((sortField === thisSortField) ? ((sortDir === 'asc') ? '▲' : '▼') : '⇅')}
    </>
  );

  return (
    <div className="table-container">
                <SchemeListTable
                    handleSort={handleSort}
                    renderSimpleSort={renderSimpleSort}
                    getMultiSortIndicatorUpDown={getMultiSortIndicatorUpDown}
                    pageData={pageData}
                    handleCellClick={handleCellClick}
                    baseScheme={baseScheme}
                    selectedScheme={selectedScheme}
                    isAddToWatchlistApplicable={isAddToWatchlistApplicable}
                />        
    </div>
  );
}            